import { Injectable } from '@angular/core';
import { UserDto } from '@app/models';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

const AUTH_PREFIX = '/auth';

@Injectable({ providedIn: 'root' })
export class UserApi extends ApiService {
  public getMyselfDetails$(): Observable<UserDto> {
    return this.get(`${AUTH_PREFIX}/myself`);
  }
}
